module.exports = __webpack_public_path__ + "img/REngineer64_ua.b7701761.webp";